import { gql } from '@apollo/client';

// ── Queries ──

export const GET_CURRENT_USER = gql`
  query GetCurrentUser($userId: ID!) {
    user(id: $userId) {
      id
      email
      phone
      role
      isActive
      personId
    }
  }
`;

export const GET_MEMBER = gql`
  query GetMember($id: ID!) {
    member(id: $id) {
      id
      firstName
      middleName
      lastName
      spiritualName
      adultName
      gender
      birthDate
      deathDate
      birthPlace
      birthLat
      birthLng
      deathPlace
      deathLat
      deathLng
      notes
      isLiving
      motherId
      fatherId
      spouseId
      displayName
      age
    }
  }
`;

export const GET_ALL_MEMBERS = gql`
  query GetAllMembers {
    members {
      members {
        id
        firstName
        middleName
        lastName
        gender
        isLiving
        displayName
        age
        motherId
        fatherId
        spouseId
      }
      total
    }
  }
`;

export const GET_MEMBERS = gql`
  query GetMembers($firstName: String, $lastName: String, $offset: Int, $limit: Int) {
    members(firstName: $firstName, lastName: $lastName, offset: $offset, limit: $limit) {
      members {
        id
        firstName
        middleName
        lastName
        gender
        isLiving
        birthDate
        birthPlace
        displayName
        age
        motherId
        fatherId
        spouseId
      }
      total
      offset
      limit
    }
  }
`;

// ── Mutations ──

export const CREATE_MEMBER = gql`
  mutation CreateMember($input: CreateMemberInput!) {
    createMember(input: $input) {
      id
      firstName
      middleName
      lastName
      spiritualName
      adultName
      gender
      birthDate
      deathDate
      birthPlace
      deathPlace
      notes
      isLiving
      motherId
      fatherId
      spouseId
      displayName
      age
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation UpdateMember($id: ID!, $input: UpdateMemberInput!) {
    updateMember(id: $id, input: $input) {
      id
      firstName
      middleName
      lastName
      spiritualName
      adultName
      gender
      birthDate
      deathDate
      birthPlace
      birthLat
      birthLng
      deathPlace
      deathLat
      deathLng
      notes
      isLiving
      motherId
      fatherId
      spouseId
      displayName
      age
    }
  }
`;

export const DELETE_MEMBER = gql`
  mutation DeleteMember($id: ID!) {
    deleteMember(id: $id)
  }
`;

export const CREATE_INVITATION = gql`
  mutation CreateInvitation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      id
      inviterId
      inviteeId
      inviteeContact
      status
      relationshipHint
      permissionLevel
      sentAt
      expiresAt
    }
  }
`;

// ── Kinship / Jaapv Zaangv queries ──

export const GET_KINSHIP_TERM = gql`
  query GetKinshipTerm($lineage: String, $relation: String!, $genderOfRelative: String!, $isOlder: Boolean) {
    kinshipTerm(lineage: $lineage, relation: $relation, genderOfRelative: $genderOfRelative, isOlder: $isOlder) {
      id
      mienTerm
      englishEquivalent
      lineage
      relation
      genderOfRelative
      isOlder
      description
    }
  }
`;

export const GET_JAAPV_ZAANGV_BY_YEAR = gql`
  query GetJaapvZaangvByYear($year: String!) {
    jaapvZaangvByYear(year: $year) {
      year
      cyclePosition
      entry {
        id
        cyclePosition
        heavenlyStem
        earthlyBranch
        stemBranch
        mienTerm
        zodiacAnimal
        element
        yinYang
      }
    }
  }
`;

export const GET_KINSHIP_TERM_TRANSLATIONS = gql`
  query GetKinshipTermTranslations($kinshipTermId: ID, $language: String) {
    kinshipTermTranslations(kinshipTermId: $kinshipTermId, language: $language) {
      translations {
        id
        kinshipTermId
        language
        term
        transliteration
        notes
      }
      total
    }
  }
`;

export const GET_KINSHIP_TERMS = gql`
  query GetKinshipTerms($lineage: String, $relation: String) {
    kinshipTerms(lineage: $lineage, relation: $relation) {
      terms {
        id
        mienTerm
        englishEquivalent
        lineage
        relation
        genderOfRelative
        isOlder
        description
      }
      total
    }
  }
`;

export const KINSHIP_BETWEEN = gql`
  query KinshipBetween($fromPersonId: ID!, $toPersonId: ID!) {
    kinshipBetweenPersons(fromPersonId: $fromPersonId, toPersonId: $toPersonId) {
      fromPersonId
      toPersonId
      mienTerm
      englishEquivalent
      lineage
      relation
      genderOfRelative
      isOlder
      description
    }
  }
`;